import * as Eq from "fp-ts/es6/Eq"

export type ActivitySettingsJob = Record<string, unknown>
export const activitySettingsJob: Eq.Eq<ActivitySettingsJob> = Eq.struct({})
export const empty: ActivitySettingsJob = {}
